<!-- Main Content -->
<div class="container mt-4">
    <!-- Title with Icon -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-store mr-2"></i> Mã QR
    </h1>
  
    <!-- Description Below Title -->
    <p class="lead mb-4">
      Quản lý thông tin nhà cung cấp và mã QR được sử dụng để nhận dạng sản phẩm. Sử dụng các tab để điều hướng giữa các phần khác nhau, bao gồm danh sách mã QR và hướng dẫn sử dụng. Nhấn "Thêm Mã QR" để tạo mã QR mới và quản lý các mã hiện có.
    </p>
  
    <!-- Navigation Tabs -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#List">
          <i class="fas fa-list mr-2"></i> Danh Sách
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#UserManual">
          <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
        </a>
      </li>
    </ul>
  
    <!-- Tab Content -->
    <div class="tab-content">
      <!-- List tab content -->
      <div id="List" class="tab-pane fade show active">
        <div class="container-fluid">
         
          <div class="card mb-4">
            <div class="card-body">

               <!-- Button trigger modal -->
          <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Thêm Mã QR</button>
           
          <button
          href="#"
          role="button"
          class="btn btn-outline-warning btn-icon-split"
          (click)="loadQRCodes()"
          >
          <span class="icon text-warning">
            <i class="fas fa-redo"></i>
          </span>
          <span class="text">Tải Lại</span>
          </button>
        <!-- QR Code Table -->
              <div class="table-responsive">
  
                <!-- Loading Indicator -->
                <div *ngIf="loadingIndicator; else loaded">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
  
                <ng-template #loaded>
                  <!-- Refresh Button -->
                  <!-- <button class="btn btn-info btn-icon-split mb-3" (click)="refreshData()">
                    <span class="icon text-white-50">
                      <i class="fas fa-sync-alt"></i>
                    </span>
                    <span class="text">Refresh</span>
                  </button> -->
  
                  <!-- Search Input -->
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search by ISBN..."
                      (input)="updateFilter($event)"
                    />
                  </div>
  
                  <!-- ngx-datatable -->
                  <ngx-datatable
                    class="bootstrap"
                    [rows]="qrCodes"
                    [columnMode]="'force'"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [rowHeight]="'auto'"
                    [limit]="10"
                    [loadingIndicator]="loadingIndicator"
                    [reorderable]="true"
                    (select)="onSelect($event)"
                    (activate)="onActivate($event)"
                  >
                  
                    <!-- ISBN -->
                    <ngx-datatable-column name="ISBN" [prop]="'isbn'">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <span style="color: red;">{{ row.isbn }}</span>
                      </ng-template>
                    </ngx-datatable-column>
  
                    <!-- Width -->
                    <ngx-datatable-column name="Width" [prop]="'width'">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.width }}
                      </ng-template>
                    </ngx-datatable-column>
  
                    <!-- Height -->
                    <ngx-datatable-column name="Height" [prop]="'height'">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.height }}
                      </ng-template>
                    </ngx-datatable-column>
  
                    <!-- Margin -->
                    <ngx-datatable-column name="Margin" [prop]="'margin'">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        {{ row.margin }}
                      </ng-template>
                    </ngx-datatable-column>
  
                    <!-- Actions -->
                    <ngx-datatable-column name="Actions">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Actions">
                          <i class="fas fa-cog"></i> Actions
                      </button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item"  (click)="openViewDialog(row)" title="Edit">
                          <i class="fas fa-eye"></i> View
                        </a>

                          <!-- <a class="dropdown-item"  (click)="openEditDialog(row)" title="Edit">
                              <i class="fas fa-edit"></i> Edit
                          </a> -->
                          <a class="dropdown-item"  (click)="deleteQRCode(row.id)" title="Delete">
                              <i class="fas fa-trash"></i> Delete
                          </a>
                          <a class="dropdown-item" (click)="regenerateQRCode(row)">
                              <i class="fas fa-qrcode"></i> Regenerate QR Code
                          </a>
                          <a class="dropdown-item" (click)="printQrCode(row)">
                              <i class="fas fa-print"></i> Print
                          </a>
                          <a class="dropdown-item" (click)="downloadQrCode(row)">
                            <i class="fas fa-download"></i> Download
                        </a>
                        
                      </div>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="printSection" style="display: none;"></div>
  
      <!-- User Manual tab content -->
    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- User Manual content here -->
      <div>
         <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
          <div  [innerHTML]="markdownContent"></div>
      </div>
    </div>
    </div>
  </div>
